import { CopyField } from '../../../shared/ui/copy-field';
import { SectionPanel } from '../../../shared/ui/section-panel';
import { hostOf } from '../../../entities/customer';
import type { TSource } from '../../../entities/source';

// On a custom domain the address on ours still answers; saying so saves a support thread.
const domainLine = (source: TSource, url: string): string => {
  const host = hostOf(url);
  if (!source.ingestHost) return `on ${host}`;
  const ours = source.addresses?.find((address) => address.host === null)?.hostname;
  return ours
    ? `on ${host} · your domain · the same address on ${ours} keeps working`
    : `on ${host} · your domain`;
};

export const ClientAddressCard = ({ source, url }: { source: TSource; url: string }) => (
  <SectionPanel title="Their address" note="theirs alone">
    <div className="flex flex-col gap-2 p-card">
      <CopyField value={url} />
      <p className="font-mono text-micro text-faint">{domainLine(source, url)}</p>
      <p className="text-meta leading-18 text-muted">
        {source.clientSecrets
          ? 'It never changes while the client exists. Everything sent here is checked against their secret below, not the source’s shared one.'
          : source.unauthenticated
            ? 'It never changes while the client exists. Requests sent here are told apart from everyone else’s, so their runs carry this client.'
            : 'It never changes while the client exists. Requests sent here are told apart from everyone else’s, so their runs carry this client, and checked against the source’s IP allowlist like any other.'}
      </p>
    </div>
  </SectionPanel>
);
